import React, { useEffect, useRef } from 'react';
import { formatLength, validateLength } from './utils';
import { toDecimalPoint } from '../../../utils/decimalUtils';
import DecimalInput from '../../fields/DecimalInput';

const InfoSection = ({ handbooks, displayData, localFormData, setLocalFormData, openPicker, clearTableData, infoTableScrollRef, infoTableScrollPosition, handleInfoTableScroll, handleInfoTableSliderChange }) => {
  const celTextareaRef = useRef(null);
  const ekolzonaTextareaRef = useRef(null);

  // Функция для автоматического изменения высоты textarea
  const adjustTextareaHeight = (textarea) => {
    if (textarea) {
      // Сбрасываем высоту, чтобы получить правильный scrollHeight
      textarea.style.height = '0px';
      // Устанавливаем высоту равной scrollHeight
      const newHeight = Math.max(80, textarea.scrollHeight);
      textarea.style.height = newHeight + 'px';
    }
  };

  // Автоматическое изменение высоты при изменении значения
  useEffect(() => {
    // Используем setTimeout, чтобы убедиться, что DOM обновлен
    const timer = setTimeout(() => {
      adjustTextareaHeight(celTextareaRef.current);
      adjustTextareaHeight(ekolzonaTextareaRef.current);
    }, 0);
    return () => clearTimeout(timer);
  }, [displayData.cel, displayData.ekolzona]);

  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>Информация</h4>
        <button 
          type="button" 
          onClick={() => clearTableData('info')}
          style={{
            background: '#6c757d',
            color: 'white',
            border: 'none',
            padding: '5px 10px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          Очистить
        </button>
      </div>
      <div 
        ref={infoTableScrollRef}
        onScroll={handleInfoTableScroll}
        style={{ 
          overflowX: 'auto', 
          overflowY: 'visible',
          maxWidth: '100%',
          border: '1px solid #ddd',
          borderRadius: '6px'
        }}
      >
        <table className="table" style={{ 
          minWidth: '1270px',
          width: 'max-content',
          marginBottom: 0
        }}>
          <thead>
            <tr>
              <th style={{ minWidth: '400px', width: '400px' }}>Цель ВНН <span className="required">*</span></th>
              <th style={{ minWidth: '150px', width: '150px' }}>Дата проведения ВНН <span className="required">*</span></th>
              <th style={{ minWidth: '250px', width: '250px' }}>Наименование зоны</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Номер маршрутного хода</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Протяжённость маршрутного хода, км</th>
              <th style={{ minWidth: '200px', width: '200px' }}>Информация пользователя</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="coordinate-cell" style={{ minWidth: '400px', width: '400px' }}>
                <div 
                  className="reference-cell"
                  onClick={() => openPicker('cel', 19)}
                  style={{ 
                    minHeight: 80, 
                    height: 'auto',
                    cursor: 'pointer',
                    background: 'transparent',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <textarea
                    ref={celTextareaRef}
                    name="cel"
                    id="form1-cel"
                    readOnly
                    value={(() => {
                      const handbook = handbooks.find(h => h.id === 19);
                      if (handbook && handbook.references && displayData.cel) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === displayData.cel);
                        return selectedOption ? selectedOption.name : '';
                      }
                      return '';
                    })()}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      width: '100%',
                      minHeight: '80px',
                      height: 'auto',
                      overflow: 'auto',
                      background: 'transparent',
                      color: displayData.cel ? '#495057' : '#6c757d',
                      fontStyle: displayData.cel ? 'normal' : 'italic',
                      lineHeight: '1.5',
                      padding: '4px 8px',
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      wordBreak: 'break-word',
                      display: 'block',
                      textAlign: 'center',
                      position: 'static',
                      boxSizing: 'border-box'
                    }}
                    className={`form-control multiline-textarea ${!displayData.cel ? 'required-field' : ''}`}
                  />
                </div>
              </td>
              <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                <input
                  type="date"
                  name="datar"
                  id="form1-datar"
                  value={displayData.datar || ''}
                  onChange={(e) => {
                    setLocalFormData(prev => ({ ...prev, datar: e.target.value }));
                  }}
                  className={`form-control coordinate-field ${!displayData.datar ? 'required-field' : ''}`}
                />
              </td>
              <td className="coordinate-cell" style={{ minWidth: '250px', width: '250px' }}>
                <div 
                  className="reference-cell"
                  onClick={() => openPicker('ekolzona', 18)}
                  style={{ 
                    minHeight: 80, 
                    height: 'auto',
                    cursor: 'pointer',
                    background: 'transparent',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <textarea
                    ref={ekolzonaTextareaRef}
                    name="ekolzona"
                    id="form1-ekolzona"
                    readOnly
                    value={(() => {
                      const handbook = handbooks.find(h => h.id === 18);
                      if (handbook && handbook.references && displayData.ekolzona) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === displayData.ekolzona);
                        return selectedOption ? selectedOption.name : '';
                      }
                      return '';
                    })()}
                    placeholder="☰"
                    style={{
                      border: 'none',
                      outline: 'none',
                      resize: 'none',
                      width: '100%',
                      minHeight: '80px',
                      height: 'auto',
                      overflow: 'auto',
                      background: 'transparent',
                      color: displayData.ekolzona ? '#495057' : '#6c757d',
                      fontStyle: displayData.ekolzona ? 'normal' : 'italic',
                      lineHeight: '1.5',
                      padding: '4px 8px',
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      wordBreak: 'break-word',
                      display: 'block',
                      textAlign: 'center',
                      position: 'static',
                      boxSizing: 'border-box'
                    }}
                    className="form-control multiline-textarea"
                  />
                </div>
              </td>
              <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                <input
                  type="text"
                  name="nmh"
                  id="form1-nmh"
                  value={displayData.nmh || ''}
                  onChange={(e) => {
                    const newData = { ...localFormData, nmh: e.target.value };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => ({ ...prev, nmh: e.target.value }));
                    }
                  }}
                  className="form-control coordinate-field"
                />
              </td>
              <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                <DecimalInput
                  name="lmh"
                  id="form1-lmh"
                  value={displayData.lmh || ''}
                  onChange={(e) => {
                    const value = toDecimalPoint(e.target.value);
                    const newData = { ...localFormData, lmh: value };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => ({ ...prev, lmh: value }));
                    }
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    const formattedValue = formatLength(value);
                    const newData = { ...localFormData, lmh: formattedValue };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => ({ ...prev, lmh: formattedValue }));
                    }
                  }}
                  className="form-control coordinate-field"
                  placeholder="0.000"
                />
              </td>
              <td className="coordinate-cell" style={{ minWidth: '200px', width: '200px' }}>
                <textarea
                  name="itaks1"
                  id="form1-itaks1"
                  value={displayData.itaks1 || ''}
                  onChange={(e) => {
                    const newData = { ...localFormData, itaks1: e.target.value };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => ({ ...prev, itaks1: e.target.value }));
                    }
                  }}
                  className="form-control coordinate-field"
                  rows="3"
                  placeholder="Дополнительная информация"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      {/* Слайдбар для прокрутки таблицы */}
      <div style={{
        marginTop: '10px',
        padding: '10px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '60px'
        }}>
          Прокрутка:
        </span>
        <input
          type="range"
          min="0"
          max="100"
          value={infoTableScrollPosition}
          onChange={handleInfoTableSliderChange}
          className="table-scroll-slider"
          style={{
            flex: 1
          }}
        />
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '30px',
          textAlign: 'right'
        }}>
          {Math.round(infoTableScrollPosition)}%
        </span>
      </div>
    </div>
  );
};

export default InfoSection;

